/**
 * GeoPST User Management Module
 * Handles User Profile Dropdown, Mobile Bottom Sheet, and Personalized UI.
 */

class UserManagement {
    constructor() {
        this.user = { name: 'المستخدم' };
        this.init();
    }

    async init() {
        this.cacheElements();
        this.bindEvents();
        await this.fetchUserInfo();
        this.setupMobileUI();
    }

    cacheElements() {
        // Desktop elements
        this.profileBtn = document.getElementById('userProfileBtn');
        this.dropdown = document.getElementById('userDropdown');
        this.dropdownName = document.getElementById('dropdownUserName');

        // Mobile elements
        this.bottomSheet = document.getElementById('userBottomSheet');
        this.bsOverlay = document.getElementById('userBottomSheetOverlay');
        this.bsName = document.getElementById('bsUserName');
        this.bsClose = document.getElementById('userBottomSheetClose');
        this.mobileUserBtn = document.getElementById('mobileUserBtn');
        this.mobileSearchForm = document.getElementById('mobileSearchForm');
    }

    bindEvents() {
        // Desktop Toggle
        if (this.profileBtn) {
            this.profileBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                this.toggleDropdown();
            });
        }

        // Mobile Profile Toggle
        if (this.mobileUserBtn) {
            this.mobileUserBtn.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.toggleBottomSheet(true);
            });
        }

        // Close dropdown/sheet when clicking outside
        document.addEventListener('click', (e) => {
            // Dropdown
            if (this.dropdown && this.dropdown.classList.contains('active')) {
                if (!this.dropdown.contains(e.target) && !this.profileBtn.contains(e.target)) {
                    this.dropdown.classList.remove('active');
                    this.profileBtn.classList.remove('active');
                }
            }
        });

        // Mobile Overlay & Close Button
        if (this.bsOverlay) {
            this.bsOverlay.addEventListener('click', () => this.toggleBottomSheet(false));
        }
        if (this.bsClose) {
            this.bsClose.addEventListener('click', (e) => {
                e.stopPropagation();
                this.toggleBottomSheet(false);
            });
        }

        // Handle swipes for bottom sheet
        if (this.bottomSheet) {
            let touchStart = 0;
            this.bottomSheet.addEventListener('touchstart', (e) => touchStart = e.touches[0].clientY);
            this.bottomSheet.addEventListener('touchmove', (e) => {
                const touchEnd = e.touches[0].clientY;
                if (touchEnd - touchStart > 80) this.toggleBottomSheet(false);
            });
        }
    }

    async fetchUserInfo() {
        try {
            const token = localStorage.getItem('map_token') || sessionStorage.getItem('map_token');
            if (!token) return;

            const response = await fetch('/api/mapAuth/verify', {
                headers: { 'Authorization': `Bearer ${token}` }
            });

            if (response.ok) {
                const data = await response.json();
                if (data.valid && data.name) {
                    this.user.name = data.name;
                    this.updateUI();
                }
            }
        } catch (err) {
            console.error('[UserManagement] Failed to fetch user info:', err);
        }
    }

    updateUI() {
        if (this.dropdownName) this.dropdownName.textContent = this.user.name;
        if (this.bsName) this.bsName.textContent = this.user.name;
    }

    toggleDropdown() {
        if (!this.dropdown) return;
        const isActive = this.dropdown.classList.contains('active');
        this.dropdown.classList.toggle('active');
        this.profileBtn.classList.toggle('active');
    }

    toggleBottomSheet(show = true) {
        if (!this.bottomSheet) return;
        if (show) {
            this.bottomSheet.classList.add('visible');
            if (this.bsOverlay) this.bsOverlay.classList.add('active');
            document.body.classList.add('bottom-sheet-active');
        } else {
            this.bottomSheet.classList.remove('visible', 'expanded');
            if (this.bsOverlay) this.bsOverlay.classList.remove('active');
            document.body.classList.remove('bottom-sheet-active');
        }
    }

    setupMobileUI() {
        // Now handled natively via HTML and CSS
    }
}

// Logout logic is now centralized in map-security.js for consistency

// Initialize on load
document.addEventListener('DOMContentLoaded', () => {
    window.UserMgmt = new UserManagement();
});

export default UserManagement;
